import { API_URL, ACTIONS } from "UTILS/Constants";
import BaseAction from "CONFIG/BaseAction";
import { HTTP_METHODS } from "UTILS/Constants";
import { selectSessionKey } from "COMPONENTS/MainLayout/selectors";

export class CreateSessionAction extends BaseAction {
  constructor() {
    super();
    BaseAction.call(this);
  }
  //never make this function as arrow function
  createSessionAction(sessionName, passcode, language) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody: {
          sessionName:
            sessionName || this.getState().SessionReducer.sessionTitle,
          passcode,
          language
        },
        url: API_URL.CREATE_USER_SESSION
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.CREATE_SESSION_SUCCESS,
            userSessionDetails: response.data.data
          });
          resolve(response);
        },
        error => {
          reject(error);
          this.dispatch({
            type: ACTIONS.CREATE_SESSION_SUCCESS,
            userSessionDetails: {sessionKey: ""}
          });
        }
      );
    });
  }

  scheduleSessionAction(sessionDetails) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody: sessionDetails,
        url: API_URL.SCHEDULE_SESSION
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.SCHEDULE_SESSION_SUCCESS,
            userSessionDetails: response.data.data
          });
          resolve(response);
        },
        error => {
          reject(error);
          this.dispatch({
            type: ACTIONS.SCHEDULE_SESSION_SUCCESS,
            userSessionDetails: null
          });
        }
      );
    });
  }

  cancelSessionAction(sessionKey, language){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.DELETE,
        url: `${API_URL.SCHEDULE_SESSION}/${sessionKey}`,
        requestBody: {language}
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.DELETE_SESSION_SUCCESS,
            userSessionDetails: response.data.data
          });
          resolve(response);
        },
        error => {
          reject(error);
          this.dispatch({
            type: ACTIONS.DELETE_SESSION_SUCCESS,
            userSessionDetails: null
          });
        }
      );
    });
  }

  getSessionListActions(filter) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        requestBody: filter,
        url: API_URL.GET_SCHEDULE_SESSION_LIST
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.SET_SESSION_SCHEDULE_LIST,
            value : response.data.data.sessionsList
          })
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  updateSessionAction = (sessionKey, sessionDetails) =>{
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.PUT,
        requestBody: sessionDetails,
        url: `${API_URL.SCHEDULE_SESSION}/${sessionKey}`
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.SCHEDULE_SESSION_SUCCESS,
            userSessionDetails: response.data.data
          });
          resolve(response);
        },
        error => {
          reject(error);
          this.dispatch({
            type: ACTIONS.SCHEDULE_SESSION_SUCCESS,
            userSessionDetails: null
          });
        }
      );
    });
  }

  joinSessionAction(sessionKey, uriIdentifier, terminalInfo = "", speedTest, userName = "", reJoinFlag = false, endUserToken = "") {
    let uriWithoutSlash = uriIdentifier ? uriIdentifier.slice(1) : undefined; // Remove first Slash in uriIdentifier
    let requestBody = {
      sessionKey: sessionKey
        ? sessionKey
        : selectSessionKey(this.getState()),
      token: endUserToken ? endUserToken : undefined,
      uriIdentifier: uriWithoutSlash
    };
    if (terminalInfo){
      requestBody.terminalInfo = terminalInfo;
    }
    if (speedTest){
      requestBody.speedTest = speedTest;
    }
    if (userName){
      requestBody.userName = userName;
    }
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody,
        url: API_URL.JOIN_SESSION
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.SET_TURN_SERVER_DATA,
            turnServer: response.data.data.turnServer
          });
          this.dispatch({
            type: ACTIONS.JOIN_SESSION,
            sessionDetails: response.data.data
          });
          this.dispatch({
            type: ACTIONS.SET_JOINING_USER_DETAILS,
            joiningUserDetails: response.data.data            
          });
          this.dispatch({
            type: ACTIONS.SET_SESSION_JOINED_FLAG,
            isSessionJoined: true
          });
          if(response.data.data.config) {
            this.dispatch({
              type: ACTIONS.SET_CONFIG,
              config: response.data.data.config,
            });
          }
          if (response.data.data.contractInfo) {
            this.setContractInfo(response.data.data.contractInfo)
          }
          if (response.data.data.sessionType) {
            this.setSessionSubType(response.data.data.sessionType)
          }
          resolve(response);
        },
        error => {
          reject(error);
          if (!reJoinFlag) {
            this.dispatch({
              type: ACTIONS.JOIN_SESSION,
              sessionDetails: {sessionKey:'',token:'',modules:[]}
            });
          }
        }
      );
    });
  }

  /**
   * set contract info from eXcloser-server
   * @param {*} contractInfo [{ label, url }, { label, url }, ...]
   */
  setContractInfo(contractInfo) {
    this.dispatch({
      type: ACTIONS.SET_CONTRACT_INFO,
      value: contractInfo,
    })
  }

  /**
   * set sessionSubType from eXcloser-server
   * @param {*} sessionSubType [{ label, url }, { label, url }, ...]
   */
  setSessionSubType(sessionSubType) {
    this.dispatch({
      type: ACTIONS.SET_SESSION_SUBTYPE,
      value: sessionSubType,
    })
  }

  /**
   * Contract Info Modal is Opened or not
   * @param {*} isOpened true: Modal is Opened, false: Modal is Closed
   */
  setIsContractInfoModalOpened(isOpened) {
    this.dispatch({
      type: ACTIONS.SET_IS_CONTRACT_INFO_MODAL_OPENED,
      value: isOpened,
    });
  }

  viewInviteesAction(searchKey) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        requestBody: {
          searchKey: searchKey
        },
        url: API_URL.VIEW_INVITEES
      }).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
  updateWebRtcPermissionReply(value) {
    this.dispatch({
      type: ACTIONS.SET_WEBRTC_REPLY_PERMISSION,
      webRtcPermissionReply: value
    });
  }
  updateWebRtcPermissionRequest(media) {
    this.dispatch({
      type: ACTIONS.SET_WEBRTC_REQUEST_PERMISSION,
      webRtcPermissionRequest: media
    });
  }
  updateSnapshotPermissionStatus(value) {
    this.dispatch({
      type: ACTIONS.SET_SNASHOT_PERMISSION_STATUS,
      snapshotPermissionStatus: value
    });
  }
  updateSnapshoteeId(uniqueId) {
    this.dispatch({
      type: ACTIONS.SET_SNAPSHOTEE_ID,
      snapshoteeId: uniqueId
    });
  }
  updateSnapshotPermissionReply(flag) {
    this.dispatch({
      type: ACTIONS.SET_SNAPSHOT_PERMISSION_REPLY,
      snapshotPermissionReply: flag
    });
  }
  setPeerDisposed(isDisposed) {
    this.dispatch({
      type: ACTIONS.SET_SWITCH_CAMERA,
      isPeerDisposed: isDisposed,
    });
  }

  checkInviteUser(participants) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody: {
          participants: participants,
        },
        url: API_URL.CHECK_INVITE_USER
      }).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  inviteUser(sessionKey, participants, language, customize = null) {
    const requestBody = customize
      ? {
        sessionKey: sessionKey,
        participants: participants,
        language,
        customize,
      }
      : {
        sessionKey: sessionKey,
        participants: participants,
        language,
      };
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody,
        url: API_URL.INVITE_USER
      }).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  isSessionJoinedAction(flag) {
    this.dispatch({
      type: ACTIONS.SET_SESSION_JOINED_FLAG,
      isSessionJoined: flag
    });
  }
  downloadChatMessages(sessionKey) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        requestBody: {
          sessionKey: sessionKey
        },
        url: API_URL.DOWNLOAD_CHAT
      }).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
  createSessionWithLicenseAction(licenseKey, selectedLanguage, sessionName) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody: {
          sessionName: sessionName,
          licenseKey: licenseKey,
          language: selectedLanguage
        },
        url: API_URL.CREATE_USER_SESSION_WITH_LICENSE
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.CREATE_SESSION_SUCCESS,
            userSessionDetails: response.data.data
          });
          resolve(response);
        },
        error => {
          reject(error);
          this.dispatch({
            type: ACTIONS.CREATE_SESSION_SUCCESS,
            userSessionDetails: {sessionKey:'',url:''}
          });
        }
      );
    });
  }
  resetShowKmsConnectionStatusAction() {
    this.dispatch({
      type: ACTIONS.RESET_SHOW_KMS_CONNECTION_STATUS
    });
  }
  setComponentInFocus(componentInFocus) {
    this.dispatch({
      type: ACTIONS.SET_COMPONENT_IN_FOCUS,
      componentInFocus: componentInFocus
    });
  }

  setSaveSessionDataFlag(flag) {
    this.dispatch({
      type: ACTIONS.SET_SAVE_SESSION_DATA_FLAG,
      flag
    });
  }

  saveSessionData(sessionKey) {
    return this.callApi({
      httpMethod: HTTP_METHODS.POST,
      url: API_URL.SAVE_SESSION_DATA,
      params: {
        sessionKey
      }
    })
    .then(() => {
      this.setSaveSessionDataFlag(false);
      return null; // response doesn't contain anything meaningful
    })
  }

  setSessionType(sessionType) {
    this.dispatch({
      type: ACTIONS.SET_SESSION_TYPE,
      sessionType
    });
  }

  editSessionAction(session) {
    this.dispatch({
      type: ACTIONS.SET_EDIT_SESSION_DATA,
      session
    })
  }

  getSessionKeyFromPasscode(sessionDetails){
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        url: API_URL.GET_SESSION_KEY_FROM_PASSCODE,
        requestBody: sessionDetails
      }).then(response => {
        resolve(response.data);
        this.dispatch({
          type: ACTIONS.SET_PASSCODE,
          passcode: sessionDetails.passcode
        });
      },
      error => {
        reject(error);
      }
      );
    });
  }

  checkSessionData(sessionKey, uriIdentifier, endUserToken = "") {
    let uriWithoutSlash = uriIdentifier ? uriIdentifier.slice(1) : undefined; // Remove first Slash in uriIdentifier
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody: {
          sessionKey: sessionKey
            ? sessionKey
            : selectSessionKey(this.getState()),
          token: endUserToken ? endUserToken : undefined,
          uriIdentifier: uriWithoutSlash
        },
        url: API_URL.CHECK_SESSION_DATA
      }).then(
        response => {
          resolve(response.data);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  getSupportCenterSessionsActions(from, page, limit, status) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.GET,
        requestBody: { from, page, limit, status },
        url: API_URL.GET_SUPPORT_CENTER_SESSIONS
      }).then(
        response => {
          resolve(response);
        },
        error => {
          reject(error);
        }
      );
    });
  }

  createSessionSupportCenterAction(licenseKey, sessionName, requirement, language, metadata) {
    return new Promise((resolve, reject) => {
      this.callApi({
        httpMethod: HTTP_METHODS.POST,
        requestBody: {
          licenseKey,
          sessionName,
          requirement,
          language,
          metadata,
        },
        url: API_URL.CREATE_USER_SESSION_SUPPORT_CENTER
      }).then(
        response => {
          this.dispatch({
            type: ACTIONS.CREATE_SESSION_SUCCESS,
            userSessionDetails: response.data.data
          });
          resolve(response);
        },
        error => {
          reject(error);
          this.dispatch({
            type: ACTIONS.CREATE_SESSION_SUCCESS,
            userSessionDetails: {sessionKey: ""}
          });
        }
      );
    });
  }

  getSupportCenterReportAction({ isCsv = false, ...requestBody }) {
    return this.callApi({
      httpMethod: HTTP_METHODS.GET,
      requestBody,
      url: API_URL.SUPPORT_CENTER_REPORT,
      header: isCsv ? { Accept: "text/csv"} : {},
      responseType: isCsv ? 'blob' : undefined,
    });
  }

  isDisconnectedWhileCallingAction(flag) {
    this.dispatch({
      type: ACTIONS.SET_IS_DISCONNECTED_WHILE_CALLING,
      value: flag,
    });
  }

  saveSpeedTestParticipantId(participantId, participantName, speedTestDisconnectUserName){
    this.dispatch({
      type: ACTIONS.SAVE_SPEED_TEST_PARTICIPANT_ID,
      speedTestParticipantId: participantId,
      speedTestParticipantName: participantName,
      speedTestDisconnectUserName,
    });
  }

  setOwnSpeedTestError(ownSpeedTestError){
    this.dispatch({
      type: ACTIONS.SPEED_TEST.SET_OWN_SPEED_TEST_ERROR,
      ownSpeedTestError,
    });
  }

  setSpeedTestExecutedFlag(speedTestExecutedFlag){
    this.dispatch({
      type: ACTIONS.SPEED_TEST.SET_SPEED_TEST_EXECUTED_FLAG,
      speedTestExecutedFlag,
    });
  }

  setWebRtcReconnectingParticipantId(participantId){
    this.dispatch({
      type: ACTIONS.SET_WEBRTC_RECONNECT_ID,
      participantId: participantId
    });
  }
}
